import { readFile, writeFile } from 'fs/promises';

/**
 * Convert CLAUDE.md to MEMORY.md
 *
 * CLAUDE.md and MEMORY.md have compatible formats.
 * Both support @import syntax and use standard markdown.
 *
 * @param sourcePath - Path to CLAUDE.md
 * @param targetPath - Path to output MEMORY.md
 */
export async function claudeToMemory(sourcePath: string, targetPath: string): Promise<void> {
  try {
    // Read CLAUDE.md content
    const content = await readFile(sourcePath, 'utf-8');

    // MEMORY.md format is compatible with CLAUDE.md
    // Just copy the content directly
    await writeFile(targetPath, content, 'utf-8');
  } catch (error) {
    throw new Error(
      `Failed to convert CLAUDE.md to MEMORY.md: ${(error as Error).message}`
    );
  }
}
